<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Assign Sub Skills to Students">
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <span class="body-2 font-weight-medium"> Class <span class="error--text">*</span> </span>
            <v-autocomplete
              class="my-0 py-1"
              :items="classes"
              key="id"
              item-value="id"
              item-text="name"
              placeholder="--Select--"
              name="classSelect"
              v-model="selectedClassID"
              required
              @change="changeSections()"
            >
            </v-autocomplete>
            <!-- :v-bind="id" -->
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <span class="body-2 font-weight-medium"> Section <span class="error--text">*</span> </span>
            <v-autocomplete
              class="my-0 py-1"
              placeholder="--Select--"
              name="sectionSelect"
              v-model="selectedSectionID"
              required
              @change="getSkills()"
              item-value="id"
              item-text="name"
              :items="classWiseSections"
              key="id"
            >
            </v-autocomplete>
            <!-- :v-bind="sectn.id" -->
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <span class="body-2 font-weight-medium"> Skills <span class="error--text">*</span> </span>
            <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="selectedSkill" required @change="getTerms()" item-text="name" item-value="id" :items="skills" key="id">
            </v-autocomplete>
            <!-- :v-bind="skill.id" -->
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <span class="body-2 font-weight-medium"> Term <span class="error--text">*</span> </span>
            <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="selectedTerm" required item-text="customName" item-value="id" :items="terms" key="academicTerm.id">
            </v-autocomplete>
          </v-col>
          <!-- :v-bind="term.academicTerm.id" -->
          <v-col cols="12" md="3">
            <span class="body-2 font-weight-medium"> Action </span>
            <div class="inside">
              <v-btn color="success" elevation="1" @click="getData()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            Total Records : {{ total }}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
          <v-btn v-if="isWrite" elevation="1" @click="save" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="primary">
            <v-icon left>mdi-content-save</v-icon>
            save
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :search="search"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.studentName="{ item }">
            <span class="text-capitalize">{{ item.studentEnrollment.studentName }}</span>
          </template>

          <template v-slot:item.gender="{ item }">
            <span class="text-uppercase">{{ item.studentEnrollment.gender }}</span>
          </template>
          <template v-slot:item.id="{ item }">
            <v-row no-gutters>
              <v-col cols="3" v-for="sub in item.gradeSubSkillMaps" :key="sub.gradeSubSkill.id">
                <v-checkbox :label="sub.gradeSubSkill.name" v-model="sub.gradeSubSkill.isChecked"></v-checkbox>
              </v-col>
            </v-row>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      classes: [],
      search: '',
      total: 0,
      selectedClassID: '',
      academicYearID: '',
      selectedSkill: '',
      inProgress: false,
      skills: [],
      selectedTerm: '',
      terms: [],
      subSkills: [],
      checkbx: [],
      isLoading: false,
      tableData: [],
      franchiseeID: '',
      isWrite: false,
      sections: [],
      selectedSectionID: '',
      classWiseSections: [],
      headers: [
        { text: 'Name', sortable: false, value: 'studentName' },
        { text: 'Gender', sortable: false, value: 'gender' },
        { text: 'SubSkills', sortable: false, value: 'id', filterable: false }
      ],
      selectedClasses: []
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    // academicYearID: async function (val) {
    //   this.selectedTerm = ''
    //   if (this.franchiseeID && this.academicYearID) {
    //     await this.getClassList()
    //   }
    //   if (this.selectedClassID && this.selectedSkill) {
    //     this.getTerms()
    //     this.tableData = []
    //     this.total = 0
    //   }
    // },
    selectedClassID () {
      this.selectedSkill = ''
      this.tableData = []
    },
    selectedSkill () {
      this.tableData = []
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    // this.getYearList()
  },
  methods: {
    save: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select Franchisee!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select Academic Year!')
        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select Class!')
        return false
      } else if (!this.selectedSectionID) {
        this.errMsg('Kinldy select Section!')
        return false
      } else if (!this.selectedSkill) {
        this.errMsg('Kinldy select Skill!')
        return false
      } else if (!this.selectedTerm) {
        this.errMsg('Kinldy select Term!')
        return false
      }

      this.isLoading = true
      var final = []
      this.tableData.map(a => {
        a.gradeSubSkillMaps.map(b => {
          final.push({
            studentAdmissionsID: a.id,
            gradeSubSkillID: b.gradeSubSkill.id,
            isActive: b.gradeSubSkill.isChecked
          })
        })
      })

      let formData = {
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        sectionID: this.selectedSectionID,
        academicTermsDateMapID: this.selectedTerm,
        gradeSkillID: this.selectedSkill,
        gradeSubSkillMaps: final
      }
      try {
        await http.post(`${constants.API_URL}/api/grade-module/grade-sub-skil-map`, formData)
        this.isLoading = false
        this.okMsg('Record added successfully!!')
        this.getData()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSubSkills: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/sub-skill?gradeSkillID=${this.selectedSkill}`)
        this.subSkills = data.length > 0 ? data[0].gradeSubSkills : []
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getData: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select Franchisee!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select Academic Year!')
        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select Class!')
        return false
      } else if (!this.selectedSectionID) {
        this.errMsg('Kinldy select Section!')
        return false
      } else if (!this.selectedSkill) {
        this.errMsg('Kinldy select Skill!')
        return false
      } else if (!this.selectedTerm) {
        this.errMsg('Kinldy select Term!')
        return false
      }
      this.isLoading = true

      await this.getSubSkills()

      try {
        let { data } = await http.get(
          `${constants.API_URL}/api/grade-module/grade-sub-skil-map?classID=${this.selectedClassID}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&gradeSkillID=${this.selectedSkill}&&academicTermsDateMapID=${this.selectedTerm}&&sectionID=${this.selectedSectionID}&&gradeIsActive=true`
        )
        this.total = data.length

        console.log('data', data, 'subskill', this.subSkills)

        data = JSON.parse(JSON.stringify(data))
        data.map(a => {
          if (a.gradeSubSkillMaps.length > 0) {
            this.subSkills.map((c, j) => {
              let r = a.gradeSubSkillMaps.some((b, i) => {
                if (b.gradeSubSkill.id === c.id) {
                  b.gradeSubSkill.isChecked = true
                  var temp
                  if (a.gradeSubSkillMaps[j]) {
                    temp = a.gradeSubSkillMaps[j]
                    a.gradeSubSkillMaps[j] = b
                    a.gradeSubSkillMaps[i] = temp
                  } else {
                    a.gradeSubSkillMaps[j] = b
                  }
                  return true
                }
              })

              if (r !== true) {
                c.isChecked = false
                let temc = JSON.parse(JSON.stringify(c))

                var t2
                if (a.gradeSubSkillMaps[j]) {
                  t2 = a.gradeSubSkillMaps[j]
                  a.gradeSubSkillMaps[j] = { 'gradeSubSkill': temc }

                  var t2indx
                  this.subSkills.some((p, pi) => {
                    if (t2.gradeSubSkill.id === p.id) {
                      t2indx = pi
                    }
                  })
                  a.gradeSubSkillMaps[t2indx] = t2
                } else {
                  a.gradeSubSkillMaps[j] = { 'gradeSubSkill': temc }
                }
              }
            })
          } else {
            this.subSkills.map(x => {
              x.isChecked = false
              let temx = JSON.parse(JSON.stringify(x))
              a.gradeSubSkillMaps.push({ gradeSubSkill: temx })
            })
          }
        })
        this.tableData = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
      // console.log('data,', this.tableData)
    },
    getTerms: async function () {
      if (!this.selectedClassID) {
        this.errMsg('Kindly select class!')
        this.terms = []
        return false
      } else if (!this.franchiseeID) {
        this.errMsg('Kindly select franchisee!')
        this.terms = []
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select academic year!')
        this.terms = []
        return false
      }

      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/grade-module/academic-terms/date/map?classID=${this.selectedClassID}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`
        )
        this.terms = data
        let t = this.terms.map(a => {
          a.toDate = moment(a.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.customName = `${a.academicTerm.name} (${a.toDate}/${a.fromDate})`
          return a
        })
        this.terms = t
        this.isLoading = false
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSkills: async function () {
      if (this.selectedClassID === '') {
        this.errMsg('Kindly select class!')
        this.tableData = []
        return false
      }
      try {
        this.isLoading = true
        this.selectedClasses.push(this.selectedClassID)
        let formData = {
          classID: this.selectedClasses
        }
        const { data } = await http.post(`${constants.API_URL}/api/v1/grade-module/skill`, formData)
        // const { data } = await http.get(`${constants.API_URL}/api/grade-module/skill?classID=${this.selectedClassID}`)
        this.skills = data.length > 0 ? data[0].gradeSkills : []
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    // getYearList: async function () {
    //   try {
    //     this.isLoading = true
    //     const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
    //     this.academicYears = data.rows
    //     this.isLoading = false
    //   } catch (e) {
    //     this.isLoading = false
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     this.errMsg(errorMessage)
    //   }
    // },
    getClassList: async function () {
      try {
        this.isLoading = true

        let response = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=false`)
        const data = response.data
        this.classes = data
        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    changeSections: async function () {
      let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
      if (sectionarray) {
        this.classWiseSections = sectionarray.sections
      } else {
        this.classWiseSections = []
      }
    },
    onFranchiseeChange: async function () {
      if (this.franchisee) {
        this.franchiseeID = this.franchisee.id
      } else {
        this.franchiseeID = ''
      }
      if (this.academicYear) {
        this.academicYearID = this.academicYear.id
      } else {
        this.academicYearID = ''
      }
      if (!this.franchiseeID) {
        Utils.helper.openDrawer(this)
      }
      if (this.franchiseeID && this.academicYearID) {
        await this.getClassList()
      }
      if (this.academicYearID && this.selectedClassID && this.franchiseeID) {
        this.getTerms()
      }
    },
    okMsg (msg) {
      return (
        this.$dialog.info({
          text: msg,
          title: 'Success'
        })
      )
    },
    errMsg (msg) {
      return (
        this.$dialog.error({
          text: msg,
          title: 'Error'
        })
      )
    }
  }
}
</script>
